// src/App.jsx

import React, {

  useEffect,

  useState,

} from "react";

import AcceptInvite from "./pages/Partner/AcceptInvite";

import {

  Routes,

  Route,

  Navigate,

  useLocation,

  useParams,

  useNavigate,

} from "react-router-dom";

import { isLtiSession } from "./ltiClaims";

import PermissionsPrompt from "./components/notifications/PermissionsPrompt";

import BottomBar from "./components/layout/BottomBar";

import ScrollManager from "./components/layout/ScrollManager";

import { PWAInstallProvider } from "./components/pwa/PWAInstallContext";



// Auth

import {

  AuthProvider,

  useAuth,

} from "./AuthContext";

import RequireAdmin from "./components/guards/RequireAdmin";

import RequirePartner from "./components/guards/RequirePartner";

import RequireLearner from "./components/guards/RequireLearner";

import RequireBusiness from "./components/guards/RequireBusiness";



// Core app pages

import Privacy from "./pages/Legal/Privacy";

import Contact from "./pages/Public/Contact";

import UserDashboard from "./pages/Learning/UserDashboard";

import QuestOverview from "./pages/Learning/QuestOverview";

import ActivityLog from "./pages/Account/ActivityLog";

import DeviceLog from "./pages/Account/DeviceLog";

import Landing from "./pages/Public/Landing";

import Login from "./pages/Auth/Login";

import PortalLogin from "./pages/Auth/PortalLogin";

import Logout from "./pages/Auth/Logout";

import Profile from "./pages/Account/Profile";

import Register from "./pages/Auth/Register";

import SessionLogs from "./pages/Admin/SessionLogs";

import Terms from "./pages/Legal/Terms";

import ResetPassword from "./pages/Auth/ResetPassword";

import AppInstallPage from "./pages/Public/AppInstall";

import InstallAndroid from "./pages/Public/InstallAndroid";

import InstallIOS from "./pages/Public/InstallIOS";

import CalendarPage from "./pages/Learning/Calendar";

import CalendarSetupPage from "./pages/Calendar/CalendarSetupPage";

import Resources from "./pages/Learning/Resources";

import ProgressDashboard from "./pages/Learning/ProgressDashboard";

import AdminDashboard from "./pages/Admin/AdminDashboard";

import JoinGwin from "./pages/Public/JoinGwin";



// Partner Portal

import PartnerLayout from "./pages/Partner/PartnerLayout";

import PartnerHome from "./pages/Partner/PartnerHome";

import PartnerAttention from "./pages/Partner/PartnerAttention";

import PartnerCohorts from "./pages/Partner/PartnerCohorts";

import PartnerPlaceholder from "./pages/Partner/PartnerPlaceholder";

import PartnerCohortDetails from "./pages/Partner/PartnerCohortDetails";

import PartnerLearners from "./pages/Partner/PartnerLearners";

import PartnerInvitations from "./pages/Partner/PartnerInvitations";

import AcceptCohortInvite from "./pages/Partner/AcceptCohortInvite";

import PartnerTeam from "./pages/Partner/PartnerTeam";

import AcceptPartnerInvite from "./pages/Admin/AcceptPartnerInvite";

import PartnerCohortProgress from "./pages/Partner/PartnerCohortProgress";

import PartnerLearnerDetails from "./pages/Partner/PartnerLearnerDetails";

import PartnerSettings from "./pages/Partner/PartnerSettings";

import PartnerReports from "./pages/Partner/PartnerReports";

import PartnerCurriculum from "./pages/Partner/PartnerCurriculum";

import PartnerSupport from "./pages/Partner/PartnerSupport";

import PartnerProgrammeActivity from "./pages/Partner/PartnerProgrammeActivity";

import PartnerResources from "./pages/Partner/PartnerResources";

import PartnerOverviewExport from "./pages/Partner/PartnerOverviewExport";



// Once-off payment return page

import OnceOffPaymentReturnPage from "./components/payfast/OnceOffPaymentReturnPage";



// Legal / policy pages

import CookiesPage from "./pages/Legal/Cookies";

import PopiaPage from "./pages/Legal/Popia";

import RefundCancellationPage from "./pages/Legal/RefundCancellation";

import ScoringFundingReadinessDisclaimerPage from "./pages/Legal/ScoringFundingReadinessDisclaimer";



// Auth callback / onboarding completion

import AuthCallback from "./pages/Auth/AuthCallback";

import ForgotPassword from "./pages/Auth/ForgotPassword";

import PilotComplete from "./pages/Public/PilotComplete";

import RequireCurrentConsents from "./components/guards/RequireCurrentConsents";



// Tracking

import SessionTracker from "./components/tracking/SessionTracker";

import RouteProgressTracker from "./components/learning/RouteProgressTracker";

import OptionalAnalyticsTracker from "./components/analytics/OptionalAnalyticsTracker";



// Runner

import FlowRunner from "./pages/Learning/FlowRunner";

import "./index.css";



// Feedback + Level Result

import LevelResult from "./pages/Quests/LevelResult";

import {

  FeedbackModal,

  FEEDBACK_PROMPTS,

} from "./components/feedback/FeedbackPrompts";



// Profile Gate

import ProfileGateRunner from "./pages/ProfileGate/ProfileGateRunner";



// Subscription route protection

import RequireSubscription from "./components/guards/RequireSubscription";



/** --- keep questId normalization consistent --- */



function normalizeQuestKey(qid) {

  if (!qid) return null;

  if (

    qid === "financial-foundations" ||

    qid === "quest-1" ||

    qid === "Q1"

  ) {

    return "1";

  }

  if (

    qid === "quest-2" ||

    qid === "Q2"

  ) {

    return "2";

  }

  if (

    qid === "quest-3" ||

    qid === "Q3"

  ) {

    return "3";

  }

  if (

    qid === "quest-4" ||

    qid === "Q4"

  ) {

    return "4";

  }

  if (

    qid === "quest-5" ||

    qid === "Q5"

  ) {

    return "5";

  }

  return String(qid);

}



/** normalize levelKey so "3", "L3", "level 3" all match */



function normalizeLevelKey(levelKey) {

  if (!levelKey) return "";

  const value = String(levelKey).trim();

  if (/^L\d+$/i.test(value)) {

    return value.toUpperCase();

  }

  if (/^\d+$/.test(value)) {

    return `L${value}`;

  }

  const match = value.match(/(\d+)/);

  return match

    ? `L${match[1]}`

    : value.toUpperCase();

}



/**

 * Add resource links ONLY for the specific levels you want.

 * Key format: `${qKey}|${subquestId}|${normalizedLevelKey}`

 *

 * IMPORTANT:

 * - subquestId here must match the EXACT value in the URL

 * - levelKey is normalized to "L3", "L2", etc

 */



const RESULT_RESOURCES = {

  // Example:

  // "1|<SUBQUEST_ID_FROM_URL>|L3": [

  //   { url: "https://...", label: "Resource 1" },

  //   { url: "https://...", label: "Resource 2" },

  // ],

};



function LevelResultRouteWrapper() {

  const {

    questId,

    subquestId,

    levelKey,

  } = useParams();

  const qKey = normalizeQuestKey(questId);

  const normalizedLevelKey =

    normalizeLevelKey(levelKey);

  const key =

    `${qKey}|${subquestId}|${normalizedLevelKey}`;

  const resources =

    RESULT_RESOURCES[key] || [];

  return (

    <LevelResult

      title="Level Result"

      resources={resources}

    />

  );

}



/** Auto-redirect public → /dashboard only if there's a real LTI learner session */



function PreAuthRedirectGate() {

  const {

    user,

    loading,

  } = useAuth();

  const {

    pathname,

  } = useLocation();

  if (loading) return null;

  const onPublicEntry =

    pathname === "/" ||

    pathname === "/landing" ||

    pathname === "/login" ||

    pathname === "/register" ||

    pathname === "/app" ||

    pathname === "/install/android" ||

    pathname === "/install/ios" ||

    pathname === "/contact" ||

    pathname === "/terms" ||

    pathname === "/privacy" ||

    pathname === "/cookies" ||

    pathname === "/popia" ||

    pathname ===

      "/refund-and-cancellation" ||

    pathname ===

      "/scoring-and-funding-readiness-disclaimer";

  if (

    isLtiSession() &&

    user &&

    onPublicEntry

  ) {

    return (

      <Navigate

        replace

        to="/dashboard"

      />

    );

  }

  return null;

}



/** Safety: /quest/:questId → /quest/:questId/subquests */



function QuestIndexRedirect() {

  const {

    questId,

  } = useParams();

  return (

    <Navigate

      replace

      to={`/quest/${questId}/subquests`}

    />

  );

}



/**

 * Wrapper to ensure password recovery ends at Login.

 */



function AuthCallbackWithRecoveryRedirect() {

  const location =

    useLocation();

  const navigate =

    useNavigate();

  const search =

    new URLSearchParams(

      location.search

    );

  const isRecovery =

    search.get("type") ===

      "recovery" ||

    (

      location.hash || ""

    ).includes("type=recovery");

  const hasRedirect =

    search.has("redirectTo");

  if (

    isRecovery &&

    !hasRedirect

  ) {

    const next = new URL(

      window.location.origin +

        location.pathname +

        location.search +

        location.hash

    );

    next.searchParams.set(

      "redirectTo",

      "/login"

    );

    navigate(

      next.pathname +

        "?" +

        next.searchParams.toString() +

        (

          location.hash || ""

        ),

      {

        replace: true,

      }

    );

    return null;

  }

  return <AuthCallback />;

}



// Global feedback host



function GlobalFeedbackHost() {

  const [open, setOpen] =

    useState(false);

  const [key, setKey] =

    useState(null);

  useEffect(() => {

    const onOpen = (event) => {

      const promptKey =

        event?.detail?.key;

      setKey(

        FEEDBACK_PROMPTS[promptKey]

          ? promptKey

          : "first_level"

      );

      setOpen(true);

    };

    window.addEventListener(

      "open-feedback-prompt",

      onOpen

    );

    return () =>

      window.removeEventListener(

        "open-feedback-prompt",

        onOpen

      );

  }, []);

  return (

    <FeedbackModal

      prompt={

        open && key

          ? FEEDBACK_PROMPTS[key]

          : null

      }

      onClose={() =>

        setOpen(false)

      }

    />

  );

}



const PWA_ENTRY_PATHS = [

  "/",

  "/landing",

  "/app",

  "/install/android",

  "/install/ios",

];



function isRunningStandalone() {

  if (typeof window === "undefined") {

    return false;

  }

  const iosStandalone =

    window.navigator.standalone === true;

  const displayModeStandalone =

    window.matchMedia?.(

      "(display-mode: standalone)"

    )?.matches === true;

  const androidStandalone =

    document.referrer?.startsWith(

      "android-app://"

    );

  return Boolean(

    iosStandalone ||

      displayModeStandalone ||

      androidStandalone

  );

}



export default function App() {

  const routerLocation =

    useLocation();

  if (

    routerLocation.pathname.startsWith(

      "//"

    )

  ) {

    const fixedPath =

      routerLocation.pathname.replace(

        /^\/+/,

        "/"

      );

    return (

      <Navigate

        replace

        to={`${fixedPath}${routerLocation.search}${routerLocation.hash}`}

      />

    );

  }

    const shouldRedirectPwaEntry =

    isRunningStandalone() &&

    PWA_ENTRY_PATHS.includes(

      routerLocation.pathname

    );

  if (shouldRedirectPwaEntry) {

    return (

      <Navigate

        replace

        to="/register"

      />

    );

  }

  const HIDE_PREFIX_ROUTES = [

    "/login",

    "/logout",

    "/register",

    "/landing",

    "/auth",

    "/privacy",

    "/terms",

    "/contact",

    "/cookies",

    "/popia",

    "/refund-and-cancellation",

    "/scoring-and-funding-readiness-disclaimer",

    "/forgot-password",

    "/profile-gate",

    "/sanity-test",

    "/play",

    "/payment",

    "/admin",

    "/partner",

    "/accept-partner-invite",

    "/accept-cohort-invite",

    "/install",

  ];

  const HIDE_EXACT_ROUTES = [
  "/",
  "/app",
  "/calendar/setup",
];

  const path =

    routerLocation.pathname;

  const shouldShowBottomBar =

    !HIDE_EXACT_ROUTES.includes(

      path

    ) &&

    !HIDE_PREFIX_ROUTES.some(

      (route) =>

        path.startsWith(route)

    );

  return (
  <PWAInstallProvider>
    <div className="flex flex-col min-h-screen">

      <PermissionsPrompt />

      <div
        id="app-scroll"
        className="flex-1"
      >
        <AuthProvider>

          <SessionTracker />

          <OptionalAnalyticsTracker />

          <ScrollManager />

          <PreAuthRedirectGate />

          <Routes>

            {/* Public routes */}

            <Route

              path="/"

              element={<Register />}

            />

            {/* Keep old /landing links working without the install-first screen. */}
            <Route path="/landing" element={<Landing />} />

            <Route

              path="/install/android"

              element={<InstallAndroid />}

            />

            <Route

              path="/install/ios"

              element={<InstallIOS />}

            />

            <Route

              path="/login"

              element={<Login />}

            />

            <Route

              path="/admin/login"

              element={

                <PortalLogin portal="admin" />

              }

            />

            <Route

              path="/partner/login"

              element={

                <PortalLogin portal="partner" />

              }

            />

            <Route

              path="/register"

              element={<Register />}

            />

            <Route

              path="/terms"

              element={<Terms />}

            />

            <Route

              path="/privacy"

              element={<Privacy />}

            />

            <Route

              path="/contact"

              element={<Contact />}

            />

            <Route

              path="/logout"

              element={<Logout />}

            />

            <Route

              path="/forgot-password"

              element={<ForgotPassword />}

            />

            <Route

              path="/reset-password"

              element={<ResetPassword />}

            />

            <Route

              path="/app"

              element={<AppInstallPage />}

            />

            <Route

              path="/accept-invite"

              element={<AcceptInvite />}

            />

            <Route

              path="/accept-cohort-invite"

              element={<AcceptCohortInvite />}

            />

            <Route

              path="/accept-partner-invite"

              element={

                <AcceptPartnerInvite />

              }

            />

            <Route

              path="/join-gwin"

              element={<JoinGwin />}

            />

            {/* Public legal / policy routes */}

            <Route

              path="/cookies"

              element={<CookiesPage />}

            />

            <Route

              path="/popia"

              element={<PopiaPage />}

            />

            <Route

              path="/refund-and-cancellation"

              element={

                <RefundCancellationPage />

              }

            />

            <Route

              path="/scoring-and-funding-readiness-disclaimer"

              element={

                <ScoringFundingReadinessDisclaimerPage />

              }

            />

            {/* Email auth callback */}

            <Route

              path="/auth/callback"

              element={

                <AuthCallbackWithRecoveryRedirect />

              }

            />

            {/* Learner profile gate */}

            <Route

              path="/profile-gate/*"

              element={

                <RequireLearner>

                  <ProfileGateRunner />

                </RequireLearner>

              }

            />

            {/* Internal Gwin admin routes */}

            <Route

              path="/admin/*"

              element={

                <RequireAdmin>

                  <AdminDashboard />

                </RequireAdmin>

              }

            />

            <Route

              path="/admin/curriculum"

              element={

                <Navigate

                  replace

                  to="/admin/users-progress"

                />

              }

            />

            {/* Partner organisation routes */}

            <Route

              path="/partner"

              element={

                <RequirePartner>

                  <PartnerLayout />

                </RequirePartner>

              }

            >

              <Route

                index

                element={<PartnerHome />}

              />

              <Route

                path="attention"

                element={<PartnerAttention />}

              />

              <Route

                path="cohorts"

                element={<PartnerCohorts />}

              />

              <Route

                path="cohorts/:cohortId"

                element={<PartnerCohortDetails />}

              />

              <Route

                path="cohorts/:cohortId/progress"

                element={<PartnerCohortProgress />}

              />

              <Route

                path="learners/:cohortLearnerId"

                element={<PartnerLearnerDetails />}

              />

              <Route

                path="curriculum"

                element={<PartnerCurriculum />}

              />

              <Route

                path="learners"

                element={<PartnerLearners />}

              />

              <Route

                path="activity"

                element={

                  <PartnerProgrammeActivity />

                }

              />

              <Route

                path="resources"

                element={

                  <PartnerResources />

                }

              />

              <Route

                path="support"

                element={<PartnerSupport />}

              />

              <Route

                path="invitations"

                element={<PartnerInvitations />}

              />

              <Route

                path="business-growth"

                element={

                  <PartnerPlaceholder

                    eyebrow="Partner · Business Growth"

                    title="Business Growth"

                    description="Review sales, employment, profit-margin, and cash-position indicators."

                  />

                }

              />

              <Route

                path="overview-export"

                element={<PartnerOverviewExport />}

              />

              <Route

                path="reports"

                element={<PartnerReports />}

              />

              <Route

                path="team"

                element={<PartnerTeam />}

              />

              <Route

                path="settings"

                element={<PartnerSettings />}

              />

              <Route

                path="*"

                element={

                  <Navigate

                    replace

                    to="/partner"

                  />

                }

              />

            </Route>

            <Route

              path="/pilot-complete"

              element={

                <PilotComplete />

              }

            />

            {/*

             * Protected learner routes:

             * learner account, completed business

             * profile and current consent required.

             */}

            <Route

              element={

                <RequireLearner>

                  <RequireBusiness />

                </RequireLearner>

              }

            >

              <Route

                element={

                  <RequireCurrentConsents />

                }

              >

                <Route
                  path="/dashboard"
                  element={
                    <ProgressDashboard />
                  }
                />

                <Route
                  path="/journey"
                  element={
                    <UserDashboard />
                  }
                />

                <Route
                  path="/home"
                  element={
                    <Navigate
                      replace
                      to="/dashboard"
                    />
                  }
                />

                <Route
                  path="/progress-dashboard"
                  element={
                    <Navigate
                      replace
                      to="/dashboard"
                    />
                  }
                />

                <Route

                  path="/calendar"

                  element={

                    <CalendarPage />

                  }

                />

                <Route
  path="/calendar/setup"
  element={
    <CalendarSetupPage />
  }
/>

                <Route

                  path="/resources"

                  element={<Resources />}

                />

                <Route

                  path="/profile"

                  element={<Profile />}

                />

                <Route

                  path="/dashboard/app"

                  element={

                    <AppInstallPage />

                  }

                />

                <Route

                  path="/quest-overview"

                  element={

                    <QuestOverview />

                  }

                />

                <Route

                  path="/activity-log"

                  element={

                    <ActivityLog />

                  }

                />

                <Route

                  path="/device-log"

                  element={

                    <DeviceLog />

                  }

                />

                <Route

                  path="/session-logs"

                  element={

                    <SessionLogs />

                  }

                />

                <Route

                  path="/dashboard/contact"

                  element={<Contact />}

                />

                {/* Once-off PayFast return route */}

                <Route

                  path="/payment/onceoff-return"

                  element={

                    <OnceOffPaymentReturnPage />

                  }

                />

                {/* Old route redirects */}

                <Route

                  path="/tasks"

                  element={

                    <Navigate

                      replace

                      to="/resources?tab=tasks"

                    />

                  }

                />

                <Route

                  path="/content-cabinet"

                  element={

                    <Navigate

                      replace

                      to="/resources"

                    />

                  }

                />

                <Route

                  path="/quest/:questId"

                  element={

                    <QuestIndexRedirect />

                  }

                />

                {/* Protected level result route */}

                <Route

                  path="/play/:questId/:subquestId/:levelKey/result"

                  element={

                    <RequireSubscription>

                      <LevelResultRouteWrapper />

                    </RequireSubscription>

                  }

                />

                {/* Protected play route */}

                <Route

                  path="/play/:questId/:subquestId/:levelKey/*"

                  element={

                    <RequireSubscription>

                      <FlowRunner />

                    </RequireSubscription>

                  }

                />

                <Route

                  path="/play/*"

                  element={

                    <Navigate

                      replace

                      to="/journey"

                    />

                  }

                />

              </Route>

            </Route>

            {/* 404 */}

            <Route

              path="*"

              element={

                <div className="p-6">

                  Not Found

                </div>

              }

            />

          </Routes>

          <RouteProgressTracker />

          {shouldShowBottomBar && (

            <BottomBar />

          )}

          <GlobalFeedbackHost />

                </AuthProvider>
      </div>
    </div>
  </PWAInstallProvider>
  );
}
